import * as TypeGraphQL from "type-graphql";
export var OptionsGreeksHistoryScalarFieldEnum;
(function (OptionsGreeksHistoryScalarFieldEnum) {
    OptionsGreeksHistoryScalarFieldEnum["id"] = "id";
    OptionsGreeksHistoryScalarFieldEnum["contractId"] = "contractId";
    OptionsGreeksHistoryScalarFieldEnum["timestamp"] = "timestamp";
    OptionsGreeksHistoryScalarFieldEnum["underlyingPrice"] = "underlyingPrice";
    OptionsGreeksHistoryScalarFieldEnum["optionPrice"] = "optionPrice";
    OptionsGreeksHistoryScalarFieldEnum["bidPrice"] = "bidPrice";
    OptionsGreeksHistoryScalarFieldEnum["askPrice"] = "askPrice";
    OptionsGreeksHistoryScalarFieldEnum["impliedVolatility"] = "impliedVolatility";
    OptionsGreeksHistoryScalarFieldEnum["delta"] = "delta";
    OptionsGreeksHistoryScalarFieldEnum["gamma"] = "gamma";
    OptionsGreeksHistoryScalarFieldEnum["theta"] = "theta";
    OptionsGreeksHistoryScalarFieldEnum["vega"] = "vega";
    OptionsGreeksHistoryScalarFieldEnum["rho"] = "rho";
    OptionsGreeksHistoryScalarFieldEnum["volume"] = "volume";
    OptionsGreeksHistoryScalarFieldEnum["openInterest"] = "openInterest";
    OptionsGreeksHistoryScalarFieldEnum["daysToExpiration"] = "daysToExpiration";
    OptionsGreeksHistoryScalarFieldEnum["intrinsicValue"] = "intrinsicValue";
    OptionsGreeksHistoryScalarFieldEnum["extrinsicValue"] = "extrinsicValue";
    OptionsGreeksHistoryScalarFieldEnum["metadata"] = "metadata";
    OptionsGreeksHistoryScalarFieldEnum["createdAt"] = "createdAt";
})(OptionsGreeksHistoryScalarFieldEnum || (OptionsGreeksHistoryScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(OptionsGreeksHistoryScalarFieldEnum, {
    name: "OptionsGreeksHistoryScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=OptionsGreeksHistoryScalarFieldEnum.js.map